/*
@example
App.log(sth);
 */
App.namespace('log', () => {
  return (...args) => {
    if (!App.debug) {
      return;
    }
    if (args && args.length === 1 && typeof args[0] === 'string') {
      console.log(`%c ${args[0]}`, 'background: #373941; color: #bada55');
    } else {
      console.log(...args);
    }
  };
});
